import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
    // A11Y (WCAG 2.1.1): the wrapper scrolls horizontally on overflow, and a
    // scrollable region needs a tab stop or keyboard users can never reach
    // the hidden columns. Only while it actually overflows — an always-on
    // tabindex is a junk stop on every non-overflowing table.
    const syncTabStop = () => {
      if (wrapper.scrollWidth > wrapper.clientWidth + 1) {
        wrapper.setAttribute('tabindex', '0');
      } else {
        wrapper.removeAttribute('tabindex');
      }
    };
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(syncTabStop).observe(wrapper);
    }
    requestAnimationFrame(syncTabStop);
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}
